import { useMemo } from "react";
import { Box, Grid } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";

import { HeatingSystemSection, SensorTableSection } from "@utilifeed/components/propai";
import { useGetFlexStations, useUpdateSensorMetaData } from "@core/apis/PropAI";

/**
 * Each host app supplies its own write via `editing`.
 * PropAI patches `/v1/flexstations/{uid}/sensors/{uid}/meta-data`.
 */
const useSensorEditing = (substationId: string) => {
  const { data: flexStations } = useGetFlexStations(substationId);
  const flexstationUid = flexStations?.[0]?.uid;

  const { mutateAsync: updateSensorMetaData } = useUpdateSensorMetaData();

  return useMemo(() => {
    if (!flexstationUid) return undefined;
    return {
      onSave: (update) =>
        updateSensorMetaData({ flexstationUid, substationUid: substationId, ...update }),
    };
  }, [flexstationUid, substationId, updateSensorMetaData]);
};

const TechnicalPage = () => {
  const { substationId } = Route.useParams();
  const editing = useSensorEditing(substationId);

  return (
    <Box p={4}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeatingSystemSection substationId={substationId} />
        </Grid>
        <Grid item xs={12}>
          <SensorTableSection substationId={substationId} editing={editing} />
        </Grid>
      </Grid>
    </Box>
  );
};

export const Route = createFileRoute(
  "/$organizationId/properties/$substationId/technical-dashboard"
)({
  component: TechnicalPage,
});
